import { useState } from "react";
import { T } from "react-translator-component";
import { Box, Button } from "@mui/material";
import ReportReasonModal from "../ReportReasonModal";

interface Props {
  post: any;
  highlightWords: string[];
}

export default function HeaderRejected({ post, highlightWords }: Props) {
  const [showReasons, setShowReasons] = useState<boolean>(false);

  if (!post) return (<></>)
  return (
    <>
      <Box sx={{ display: "flex" }}>
        {post.is_reported && (
          <Button
            onClick={() => setShowReasons(true)}
            color={"secondary"}
            variant="text"
          >
            {T("mng_rejected_posts_report_reasons")}
          </Button>
        )}
      </Box>

      <ReportReasonModal
        open={showReasons}
        post={post}
        highlightWords={highlightWords}
        onClose={() => setShowReasons(false)}
      />
    </>
  );
}
